import { ReactNode } from "react";

// @mui material components
import Icon from "@mui/material/Icon";
import { Theme } from "@mui/material/styles";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS contexts
import { useMaterialUIController } from "context";

interface Props {
  width?: string | number;
  children: ReactNode;
  sorted?: false | "none" | "asce" | "desc";
  align?: "left" | "right" | "center";
  onClick?: () => void;
}

function DataTableHeadCell({
  width,
  children,
  sorted,
  align,
  onClick,
  ...rest
}: Props): JSX.Element {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      component="th"
      width={width}
      py={1.5}
      px={1}
      sx={({ palette: { light }, borders: { borderWidth } }: Theme) => ({
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
      })}
    >
      <MDBox
        display="flex"
        alignItems="center"
        gap={0.5}
        position="relative"
        textAlign={align}
        width="max-content"
        color={darkMode ? "white" : "secondary"}
        opacity={0.7}
        onClick={onClick}
        sx={({ typography: { size, fontWeightBold } }: Theme) => ({
          fontSize: size.xxs,
          fontWeight: fontWeightBold,
          textTransform: "uppercase",
          cursor: sorted !== "none" ? "pointer" : "default",
          userSelect: sorted !== "none" ? "none" : "auto",
        })}
      >
        {children}
        {sorted === "asce" && <Icon sx={{ fontSize: "16px", mt: "2px" }}>arrow_upward</Icon>}
        {sorted === "desc" && <Icon sx={{ fontSize: "16px", mt: "2px" }}>arrow_downward</Icon>}
      </MDBox>
    </MDBox>
  );
}

DataTableHeadCell.defaultProps = {
  width: "auto",
  sorted: "none",
  align: "left",
};

export default DataTableHeadCell;
